import { mapGetters, mapMutations } from "vuex";

export default {
  name: "seminar-professional-only-popup",
  computed: {
    ...mapGetters({
      seminarInfoContent: "popups/showSeminarInfoContent",
    }),
  },
  created() {
    document.getElementById("html").classList.add("hide");
  },
  methods: {
    ...mapMutations({
      changeSeminarProfessionalOnlyPopup: "popups/SHOW_SEMINAR_PROFESSIONAL_ONLY_POPUP",
      changeRegistrationPopup: "popups/CHANGE_REGISTRATION_POPUP",
    }),
    handleOpenRegister() {
      this.changeSeminarProfessionalOnlyPopup(false)
      this.changeRegistrationPopup(true);
    }
  }
};
